export const getRandomDelay = () => Math.floor(Math.random() * 500) + 1000;
